import {
  LinkedHashSetClassDesc202cqq5740j6e as LinkedHashSetClassDesc,
  ArrayListClassDesc2euexqfjnihq7 as ArrayListClassDesc,
  HashSetClassDesc1sva99tssxbb4 as HashSetClassDesc,
  HashMapClassDesc33bep136pd9y6 as HashMapClassDesc,
  LinkedHashMapClassDesc1yxtovbec4ruk as LinkedHashMapClassDesc,
  ArrayClassDesc2voesact8ugbc as ArrayClassDesc,
  PrimitiveArrayDescriptor3bvg9e2uulc3b as PrimitiveArrayDescriptor,
} from './CollectionDescriptors.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { toNativeArrayImpl3ha7yn5cjhfpi as toNativeArrayImpl } from './Platform.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { PrimitiveKindndgbuh6is7ze as PrimitiveKind } from '../descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetSerializerClass;
function LinkedHashSetSerializer() {
  if (LinkedHashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.z1t_1 = new (LinkedHashSetClassDesc())(eSerializer.g1m());
      }
      g1m() {
        return this.z1t_1;
      }
      a1u() {
        // Inline function 'kotlin.collections.linkedSetOf' call
        return LinkedHashSet().s2();
      }
      b1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      c1u(_this__u8e3s4) {
        return this.b1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      d1u(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      e1u(_this__u8e3s4) {
        return this.d1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      f1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashSet().c3(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      g1u(_this__u8e3s4) {
        return this.f1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1u(_this__u8e3s4, size) {
      }
      i1u(_this__u8e3s4, size) {
        return this.h1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      j1u(_this__u8e3s4, index, element) {
        _this__u8e3s4.i2(element);
      }
      k1u(_this__u8e3s4, index, element) {
        return this.j1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'LinkedHashSetSerializer');
    LinkedHashSetSerializerClass = $;
  }
  return LinkedHashSetSerializerClass;
}
var ArrayListSerializerClass;
function ArrayListSerializer() {
  if (ArrayListSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(element) {
        super(element);
        this.v1u_1 = new (ArrayListClassDesc())(element.g1m());
      }
      g1m() {
        return this.v1u_1;
      }
      a1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().p2();
      }
      w1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      c1u(_this__u8e3s4) {
        return this.w1u(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      x1u(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      e1u(_this__u8e3s4) {
        return this.x1u(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      y1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? ArrayList().j2(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      g1u(_this__u8e3s4) {
        return this.y1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      z1u(_this__u8e3s4, size) {
        return _this__u8e3s4.h8(size);
      }
      i1u(_this__u8e3s4, size) {
        return this.z1u(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      a1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.b5(index, element);
      }
      k1u(_this__u8e3s4, index, element) {
        return this.a1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ArrayListSerializer');
    ArrayListSerializerClass = $;
  }
  return ArrayListSerializerClass;
}
var HashSetSerializerClass;
function HashSetSerializer() {
  if (HashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.c1v_1 = new (HashSetClassDesc())(eSerializer.g1m());
      }
      g1m() {
        return this.c1v_1;
      }
      a1u() {
        return HashSet().ga();
      }
      d1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      c1u(_this__u8e3s4) {
        return this.d1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      e1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      e1u(_this__u8e3s4) {
        return this.e1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      f1u(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashSet().ha(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      g1u(_this__u8e3s4) {
        return this.f1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      f1v(_this__u8e3s4, size) {
      }
      i1u(_this__u8e3s4, size) {
        return this.f1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      g1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.i2(element);
      }
      k1u(_this__u8e3s4, index, element) {
        return this.g1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'HashSetSerializer');
    HashSetSerializerClass = $;
  }
  return HashSetSerializerClass;
}
var HashMapSerializerClass;
function HashMapSerializer() {
  if (HashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.j1v_1 = new (HashMapClassDesc())(kSerializer.g1m(), vSerializer.g1m());
      }
      g1m() {
        return this.j1v_1;
      }
      k1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      l1v(_this__u8e3s4) {
        return this.k1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m1v(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      n1v(_this__u8e3s4) {
        return this.m1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      a1u() {
        return HashMap().r8();
      }
      o1v(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      c1u(_this__u8e3s4) {
        return this.o1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      p1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      e1u(_this__u8e3s4) {
        return this.p1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      q1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashMap().g9(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      g1u(_this__u8e3s4) {
        return this.q1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r1v(_this__u8e3s4, size) {
      }
      i1u(_this__u8e3s4, size) {
        return this.r1v(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'HashMapSerializer');
    HashMapSerializerClass = $;
  }
  return HashMapSerializerClass;
}
var LinkedHashMapSerializerClass;
function LinkedHashMapSerializer() {
  if (LinkedHashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.y1v_1 = new (LinkedHashMapClassDesc())(kSerializer.g1m(), vSerializer.g1m());
      }
      g1m() {
        return this.y1v_1;
      }
      k1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      l1v(_this__u8e3s4) {
        return this.k1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m1v(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      n1v(_this__u8e3s4) {
        return this.m1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      a1u() {
        return LinkedHashMap().ec();
      }
      z1v(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      c1u(_this__u8e3s4) {
        return this.z1v(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      a1w(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      e1u(_this__u8e3s4) {
        return this.a1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      q1v(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashMap().gc(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      g1u(_this__u8e3s4) {
        return this.q1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      b1w(_this__u8e3s4, size) {
      }
      i1u(_this__u8e3s4, size) {
        return this.b1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'LinkedHashMapSerializer');
    LinkedHashMapSerializerClass = $;
  }
  return LinkedHashMapSerializerClass;
}
var ReferenceArraySerializerClass;
function ReferenceArraySerializer() {
  if (ReferenceArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(kClass, eSerializer) {
        super(eSerializer);
        this.d1w_1 = kClass;
        this.e1w_1 = new (ArrayClassDesc())(eSerializer.g1m());
      }
      g1m() {
        return this.e1w_1;
      }
      f1w(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      l1v(_this__u8e3s4) {
        return this.f1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g1w(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
      }
      n1v(_this__u8e3s4) {
        return this.g1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      a1u() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().p2();
      }
      h1w(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      c1u(_this__u8e3s4) {
        return this.h1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      i1w(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.d1w_1);
      }
      e1u(_this__u8e3s4) {
        return this.i1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      j1w(_this__u8e3s4) {
        return ArrayList().j2(asList(_this__u8e3s4));
      }
      g1u(_this__u8e3s4) {
        return this.j1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      k1w(_this__u8e3s4, size) {
        return _this__u8e3s4.h8(size);
      }
      i1u(_this__u8e3s4, size) {
        return this.k1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      l1w(_this__u8e3s4, index, element) {
        _this__u8e3s4.b5(index, element);
      }
      k1u(_this__u8e3s4, index, element) {
        return this.l1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ReferenceArraySerializer');
    ReferenceArraySerializerClass = $;
  }
  return ReferenceArraySerializerClass;
}
var CollectionSerializerClass;
function CollectionSerializer() {
  if (CollectionSerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      m1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      l1v(_this__u8e3s4) {
        return this.m1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n1u(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      n1v(_this__u8e3s4) {
        return this.n1u((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
    }
    initMetadataForClass($, 'CollectionSerializer');
    CollectionSerializerClass = $;
  }
  return CollectionSerializerClass;
}
var MapLikeSerializerClass;
function MapLikeSerializer() {
  if (MapLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(keySerializer, valueSerializer) {
        super();
        this.s1v_1 = keySerializer;
        this.t1v_1 = valueSerializer;
      }
      u1v(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().n2(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.q3_1;
        var last = progression.r3_1;
        var step_0 = progression.s3_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.v1v(decoder, startIndex + index | 0, builder, false);
          }
           while (!(index === last));
      }
      q1u(decoder, builder, startIndex, size) {
        return this.u1v(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), startIndex, size);
      }
      v1v(decoder, index, builder, checkIndex) {
        var key = decoder.k1r(this.g1m(), index, this.s1v_1);
        var tmp;
        if (checkIndex) {
          // Inline function 'kotlin.also' call
          var this_0 = decoder.o1r(this.g1m());
          // Inline function 'kotlin.require' call
          if (!(this_0 === (index + 1 | 0))) {
            var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
            throw IllegalArgumentException().n2(toString(message));
          }
          tmp = this_0;
        } else {
          tmp = index + 1 | 0;
        }
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.s4(key)) {
          var tmp_2 = this.t1v_1.g1m().c1p();
          tmp_1 = !(tmp_2 instanceof PrimitiveKind());
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = decoder.j1r(this.g1m(), vIndex, this.t1v_1, getValue(builder, key));
        } else {
          tmp_0 = decoder.k1r(this.g1m(), vIndex, this.t1v_1);
        }
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.x4(key, value);
      }
      r1u(decoder, index, builder, checkIndex) {
        return this.v1v(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), checkIndex);
      }
      p1u(encoder, value) {
        var size = this.l1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.g1m();
        var composite = encoder.u1s(descriptor, size);
        var iterator = this.n1v(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = iterator;
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var k = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var v = element.n3();
          var tmp = this.g1m();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          composite.p1s(tmp, _unary__edvuaz, this.s1v_1, k);
          var tmp_0 = this.g1m();
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          composite.p1s(tmp_0, _unary__edvuaz_0, this.t1v_1, v);
        }
        composite.y1q(descriptor);
      }
      h1m(encoder, value) {
        return this.p1u(encoder, value);
      }
    }
    initMetadataForClass($, 'MapLikeSerializer');
    MapLikeSerializerClass = $;
  }
  return MapLikeSerializerClass;
}
var CollectionLikeSerializerClass;
function CollectionLikeSerializer() {
  if (CollectionLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(elementSerializer) {
        super();
        this.o1u_1 = elementSerializer;
      }
      p1u(encoder, value) {
        var size = this.l1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.g1m();
        var composite = encoder.u1s(descriptor, size);
        var iterator = this.n1v(value);
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.p1s(this.g1m(), index, this.o1u_1, iterator.r1());
          }
           while (inductionVariable < size);
        composite.y1q(descriptor);
      }
      h1m(encoder, value) {
        return this.p1u(encoder, value);
      }
      q1u(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().n2(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.r1u(decoder, startIndex + index | 0, builder, false);
          }
           while (inductionVariable < size);
      }
      r1u(decoder, index, builder, checkIndex) {
        this.k1u(builder, index, decoder.k1r(this.g1m(), index, this.o1u_1));
      }
    }
    initMetadataForClass($, 'CollectionLikeSerializer');
    CollectionLikeSerializerClass = $;
  }
  return CollectionLikeSerializerClass;
}
function readSize($this, decoder, builder) {
  var size = decoder.p1r($this.g1m());
  $this.i1u(builder, size);
  return size;
}
var AbstractCollectionSerializerClass;
function AbstractCollectionSerializer() {
  if (AbstractCollectionSerializerClass === VOID) {
    class $ {
      t1u(decoder, previous) {
        var tmp1_elvis_lhs = previous == null ? null : this.g1u(previous);
        var builder = tmp1_elvis_lhs == null ? this.a1u() : tmp1_elvis_lhs;
        var startIndex = this.c1u(builder);
        var compositeDecoder = decoder.x1q(this.g1m());
        if (compositeDecoder.n1r()) {
          this.q1u(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
        } else {
          $l$loop: while (true) {
            var index = compositeDecoder.o1r(this.g1m());
            if (index === -1)
              break $l$loop;
            this.s1u(compositeDecoder, startIndex + index | 0, builder);
          }
        }
        compositeDecoder.y1q(this.g1m());
        return this.e1u(builder);
      }
      i1m(decoder) {
        return this.t1u(decoder, null);
      }
      s1u(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
          this.r1u(decoder, index, builder, checkIndex);
          tmp = Unit_instance;
        } else {
          tmp = $super.r1u.call(this, decoder, index, builder, checkIndex);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer()]);
    AbstractCollectionSerializerClass = $;
  }
  return AbstractCollectionSerializerClass;
}
var PrimitiveArraySerializerClass;
function PrimitiveArraySerializer() {
  if (PrimitiveArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(primitiveSerializer) {
        super(primitiveSerializer);
        this.n1w_1 = new (PrimitiveArrayDescriptor())(primitiveSerializer.g1m());
      }
      g1m() {
        return this.n1w_1;
      }
      o1w(_this__u8e3s4) {
        return _this__u8e3s4.p1w();
      }
      c1u(_this__u8e3s4) {
        return this.o1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      q1w(_this__u8e3s4) {
        return _this__u8e3s4.r1w();
      }
      e1u(_this__u8e3s4) {
        return this.q1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      s1w(_this__u8e3s4, size) {
        return _this__u8e3s4.t1w(size);
      }
      i1u(_this__u8e3s4, size) {
        return this.s1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      u1w(_this__u8e3s4) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use writeContents instead';
        throw IllegalStateException().o(toString(message));
      }
      n1v(_this__u8e3s4) {
        return this.u1w(_this__u8e3s4);
      }
      v1w(_this__u8e3s4, index, element) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use Builder.append instead';
        throw IllegalStateException().o(toString(message));
      }
      k1u(_this__u8e3s4, index, element) {
        return this.v1w(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
      a1u() {
        return this.g1u(this.w1w());
      }
      z1w(encoder, value) {
        var size = this.l1v(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.n1w_1;
        var composite = encoder.u1s(descriptor, size);
        this.y1w(composite, value, size);
        composite.y1q(descriptor);
      }
      h1m(encoder, value) {
        return this.z1w(encoder, value);
      }
      p1u(encoder, value) {
        return this.z1w(encoder, value);
      }
      i1m(decoder) {
        return this.t1u(decoder, null);
      }
    }
    initMetadataForClass($, 'PrimitiveArraySerializer');
    PrimitiveArraySerializerClass = $;
  }
  return PrimitiveArraySerializerClass;
}
var PrimitiveArrayBuilderClass;
function PrimitiveArrayBuilder() {
  if (PrimitiveArrayBuilderClass === VOID) {
    class $ {
      a1x(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.p1w() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
          this.t1w(requiredCapacity);
          tmp = Unit_instance;
        } else {
          tmp = $super.t1w.call(this, requiredCapacity);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayBuilder');
    PrimitiveArrayBuilderClass = $;
  }
  return PrimitiveArrayBuilderClass;
}
//region block: exports
export {
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  HashMapSerializer as HashMapSerializer10v33y6rrzgrh,
  HashSetSerializer as HashSetSerializer1nieavib0jif1,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  PrimitiveArrayBuilder as PrimitiveArrayBuilder1tzna3i4eqw54,
  PrimitiveArraySerializer as PrimitiveArraySerializer6xcmeltdozbx,
  ReferenceArraySerializer as ReferenceArraySerializer3juj1vqolxkrs,
};
//endregion

//# sourceMappingURL=CollectionSerializers.mjs.map
